// generated by Neptune Namespaces v4.x.x
// file: Caffeine.Eight/Nodes/index.js

(module.exports = require('./namespace'))

.addModules({
  EmptyNode:         require('./EmptyNode'),
  EmptyOptionalNode: require('./EmptyOptionalNode'),
  Node:              require('./Node'),
  ScratchNode:       require('./ScratchNode')
});